export enum THEME_OPTION {
  LIGHT = 'LIGHT',
  DARK = 'DARK'
}

export enum FONT_OPTION {
  SEGEO_UI = 'Segoe UI',
  SAN_FRANCISCO = 'San Francisco',
  ARIAL = 'Arial',
  COMIC_SANS_MS = 'Comic Sans MS',
  VERDANA = 'Verdana',
  TAHOMA = 'Tahoma',
  TREBUCHET_MS = 'Trebuchet MS',
  HELVETICA = 'Helvetica',
  INTEL_ONE_MONO = 'Intel One Mono',
  OPEN_DYSLEXIC = 'Open Dyslexic',
  CENTURY_GOTHIC = 'Century Gothic',
  ROBOTO = 'Roboto',
  POPPINS = 'Poppins',
  SANS = 'Sans'
}

export enum SPINNER {
  DOT_WAVE = 'dotWave',
  DEFAULT = 'default'
}

export enum INPUT_TYPE {
  TEXT = 'text',
  PASSWORD = 'password',
  EMAIL = 'email',
  NUMBER = 'number',
  DATE = 'date',
  TIME = 'time',
  CHECKBOX = 'checkbox',
  RADIO = 'radio',
  SELECT = 'select',
  TEXTAREA = 'textarea',
  FILE = 'file',
  BUTTON = 'button',
  SUBMIT = 'submit',
  RESET = 'reset'
}

export enum FLOATING_LABEL_INPUT_VARIANT {
  DEFAULT = 'default',
  OUTLINED = 'outlined',
  FILLED = 'filled',
  MINIMAL = 'minimal'
}

export enum THEME_TOGGLE_VARIANT {
  ICON_ONLY = 'icon-only',
  FULL = 'full'
}

export enum CSS_DISPLAY {
  NONE = 'none'
}

export enum MODAL_TITLE_LAYOUT {
  STACK = 'stack',
  INLINE = 'inline'
}

/** Start-modal draft vs live mid-session amend. */
export enum SESSION_TASKS_EDITOR_MODE {
  DRAFT = 'draft',
  LIVE = 'live'
}

/** Row body inside the sortable session-task list. */
export enum SESSION_TASK_ROW_CONTENT {
  DISPLAY = 'display',
  EDITABLE = 'editable'
}

export enum CHIP_VARIANT {
  FILLED = 'filled',
  OUTLINED = 'outlined',
  GHOST = 'ghost',
  WARNING = 'warning',
  CAUTION = 'caution',
  SUCCESS = 'success',
  INFO = 'info',
  DANGER = 'danger',
  AI = 'ai'
}

export enum CHIP_SIZE {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg'
}

export enum COUNT_BADGE_VARIANT {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  DESTRUCTIVE = 'destructive',
  SUCCESS = 'success',
  WARNING = 'warning',
  INFO = 'info'
}

export enum COUNT_BADGE_SIZE {
  XS = 'xs',
  SM = 'sm',
  MD = 'md'
}

export enum CARD_VARIANT {
  DEFAULT = 'default',
  OUTLINED = 'outlined',
  ELEVATED = 'elevated',
  FILLED = 'filled',
  MINIMAL = 'minimal',
  GHOST = 'ghost'
}

export enum CARD_SIZE {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large'
}

/** DOM `KeyboardEvent.key` values used by interactive controls. */
export enum KEYBOARD_KEY {
  ARROW_LEFT = 'ArrowLeft',
  ARROW_RIGHT = 'ArrowRight',
  ARROW_UP = 'ArrowUp',
  ARROW_DOWN = 'ArrowDown',
  ENTER = 'Enter',
  ESCAPE = 'Escape'
}

export enum FLOATING_WORKSPACE_ORIENTATION {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical'
}

export enum FLOATING_WORKSPACE_VARIANT {
  CLUSTER = 'cluster',
  SPEED_DIAL = 'speed-dial'
}

export enum FLOATING_WORKSPACE_PANEL_SIZE {
  HALF = 'half',
  FULL = 'full'
}

export enum FLOATING_WORKSPACE_POSITION {
  BOTTOM_RIGHT = 'bottom-right',
  BOTTOM_CENTER = 'bottom-center',
  LEFT_CENTER = 'left-center',
  RIGHT_CENTER = 'right-center'
}

export enum FLOATING_WORKSPACE_PLACEMENT {
  FIXED = 'fixed',
  ABSOLUTE = 'absolute',
  INLINE = 'inline'
}

/** Anchored popover placement relative to its trigger (Radix-like). */
export enum POPOVER_SIDE {
  TOP = 'top',
  BOTTOM = 'bottom',
  LEFT = 'left',
  RIGHT = 'right'
}

export enum POPOVER_ALIGN {
  START = 'start',
  CENTER = 'center',
  END = 'end'
}
